'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeListenerMapFromUnreadyQueue = exports.resetListenerMap = exports.removeStateKeys = exports.removeEventListener = exports.removeAction = exports.getListenerMap = exports.injectStateKeys = exports.injectEventListener = exports.injectAction = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                                               * Copyright 2013-2015, Hudl
                                                                                                                                                                                                                                                                               * All rights reserved.
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * This source code is licensed under the BSD-style license found in the
                                                                                                                                                                                                                                                                               * LICENSE file in the root directory of this source tree. An additional grant
                                                                                                                                                                                                                                                                               * of patent rights can be found in the PATENTS file in the same directory.
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * @providesModule Injection
                                                                                                                                                                                                                                                                               */

var _UpdateState = require('./UpdateState');

var _UpdateState2 = _interopRequireDefault(_UpdateState);

var _State = require('./State');

var _State2 = _interopRequireDefault(_State);

var _Listener = require('./Listener');

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _VideoActions = require('../VideoActions');

var _find = require('lodash/find');

var _find2 = _interopRequireDefault(_find);

var _store = require('../../store');

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * @internal
 * Used in the `BindVideoEvents` call to handle injections
 */
var listenerVideoMap = {};
var NO_PLAYER_READY = 'NO_PLAYER_READY';

function injectEventListener(event, cb, playerId) {
  var requiredPlayerId = playerId || Object.keys(_store2.default.storeInstance().getState().players)[0] || NO_PLAYER_READY;
  var player = _store2.default.getPlayerInstance(requiredPlayerId);
  /*
   * the callback from the event
   *
   * We essentially give the components an `setState` equivalent
   * where we run the `setState` internally.
   */
  function wrappedCallback() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var updateStateResults = cb.apply(undefined, [_State2.default.getCachedSnapshot(), _UpdateState2.default, requiredPlayerId].concat(args));

    if ((typeof updateStateResults === 'undefined' ? 'undefined' : _typeof(updateStateResults)) === 'object') {
      (0, _UpdateState2.default)(updateStateResults);
    }
  }

  if (!listenerVideoMap[requiredPlayerId]) {
    listenerVideoMap[requiredPlayerId] = [];
  }

  /*
   * make sure injection doesn thappen more than once
   */
  if (process.env.NODE_ENV !== 'production') {
    (0, _invariant2.default)(!(0, _find2.default)(listenerVideoMap[requiredPlayerId], { cb: cb }), 'Multiple injection error. For memory concerns, "injectEventListener" should only be called once. ' + 'Best practice would be the constructor or componentDidMount.');
  }

  listenerVideoMap[requiredPlayerId].push({
    callback: wrappedCallback,
    cb: cb,
    event: event
  });

  if (player && player.addEventListener) {
    player.addEventListener(event, wrappedCallback);
  }
}

function removeEventListener(event, cb, playerId) {
  var requiredPlayerId = playerId || Object.keys(_store2.default.storeInstance().getState().players)[0] || '';
  var callbackObject = (0, _find2.default)(listenerVideoMap[requiredPlayerId], { cb: cb });
  var player = _store2.default.getPlayerInstance(requiredPlayerId);

  // make sure removals only called on already injected listeners
  if (process.env.NODE_ENV !== 'production') {
    (0, _invariant2.default)(callbackObject, 'RemoveEventListener error. You are trying to remove the event listener for', event, '#', cb, '. Make sure the injection happened.');
  }

  listenerVideoMap[requiredPlayerId].splice(listenerVideoMap[requiredPlayerId].indexOf(callbackObject), 1);

  if (player && player.removeEventListener) {
    player.removeEventListener(event, callbackObject.callback);
  }
}

function injectStateKeys(rootKey, stateAdditions) {
  if (process.env.NODE_ENV !== 'production') {
    (0, _invariant2.default)(typeof rootKey === 'string', 'injectStateKeys(' + rootKey + ', [object]) expects a string as it\'s first argument.');
  }

  if (!_store2.default.storeInstance().getState()[rootKey] && !_State2.default.state[rootKey]) {
    _State2.default.setState(rootKey, stateAdditions);
    var forcedUpdate = {};
    forcedUpdate[rootKey] = stateAdditions;
  }
  (0, _Listener.listener)(_State2.default.generateSnapshot(false));
}

function removeStateKeys() {
  for (var _len2 = arguments.length, keys = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    keys[_key2] = arguments[_key2];
  }

  keys.forEach(function (k) {
    if (process.env.NODE_ENV !== 'production') {
      (0, _invariant2.default)(_State2.default.state[k] !== undefined, 'Trying to remove from state "' + k + '" but nothing has been injected at that point.\n        Check call of `removeStateKeys(\'' + k + '\')`');

      // undocumented feature which is specific to the VPE.
      (0, _invariant2.default)(!_State2.default.state[k].hasOwnProperty('_persisted'), 'Trying to remove a persisted state key, "' + k + '", but this is not allowed.');
    }

    _State2.default.deleteRootFromState(k);
  });

  (0, _Listener.listener)(_State2.default.generateSnapshot(false));
}

function injectAction(name, actionFunction) {
  if (process.env.NODE_ENV !== 'production') {
    (0, _invariant2.default)(typeof name === 'string' && typeof actionFunction === 'function', 'TypeError: injectAction(name: string, actionFunction: Function) arguments are not correct\n       Check the call for \'injectAction(' + name + ', Function)\'');

    (0, _invariant2.default)(!_VideoActions.actions[name], 'Injected action "' + name + '" is already used. You must use a unique name for injecting actions');
  }

  function wrappedActionFunction() {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    var updateStateResults = actionFunction.apply(undefined, [_State2.default.generateSnapshot(false)].concat(args, [_UpdateState2.default]));

    if ((typeof updateStateResults === 'undefined' ? 'undefined' : _typeof(updateStateResults)) === 'object') {
      (0, _UpdateState2.default)(updateStateResults);
    }
  }

  (0, _VideoActions.addAction)(name, wrappedActionFunction);
}

function removeAction(name) {
  if (process.env.NODE_ENV !== 'production') {
    (0, _invariant2.default)(_VideoActions.actions[name], 'Trying to remove action "' + name + '". However, it is not a valid action currently.');
  }

  (0, _VideoActions.removeActionByName)(name);
}

function resetListenerMap() {
  listenerVideoMap = {};
}

function getListenerMap() {
  return listenerVideoMap;
}

function mergeListenerMapFromUnreadyQueue() {
  var playerKeys = Object.keys(listenerVideoMap);
  var playerIds = playerKeys.filter(function (k) {
    return k !== NO_PLAYER_READY;
  });

  if (listenerVideoMap.NO_PLAYER_READY) {
    playerIds.forEach(function (playerId) {
      listenerVideoMap[playerId] = listenerVideoMap[playerId].concat(listenerVideoMap.NO_PLAYER_READY);
    });
    delete listenerVideoMap.NO_PLAYER_READY;
  }
}

// Public API. Exposed to components
exports.injectAction = injectAction;
exports.injectEventListener = injectEventListener;
exports.injectStateKeys = injectStateKeys;
exports.getListenerMap = getListenerMap;
exports.removeAction = removeAction;
exports.removeEventListener = removeEventListener;
exports.removeStateKeys = removeStateKeys;
exports.resetListenerMap = resetListenerMap;
exports.mergeListenerMapFromUnreadyQueue = mergeListenerMapFromUnreadyQueue;